var _radialGradient, _radialGradient2, _radialGradient3, _radialGradient4, _radialGradient5, _radialGradient6, _radialGradient7, _radialGradient8, _radialGradient9, _radialGradient10, _radialGradient11, _radialGradient12, _radialGradient13, _radialGradient14, _radialGradient15, _radialGradient16, _radialGradient17, _radialGradient18, _radialGradient19, _radialGradient20, _radialGradient21, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconRabbit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: 379.673,
    cy: 428.533,
    gradientTransform: "matrix(-.99 .48 -.534 -.865 1012.008 616.848)",
    gradientUnits: "userSpaceOnUse",
    r: 59.152
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0101,
    stopColor: "#e7a561"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1583,
    stopColor: "#e8a765"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3142,
    stopColor: "#e9ae72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4736,
    stopColor: "#ecba87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6345,
    stopColor: "#f1cba4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7418,
    stopColor: "#f4d8bc"
  }))), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_2_",
    cx: 201.903,
    cy: 438.51,
    gradientUnits: "userSpaceOnUse",
    r: 99.069
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1075,
    stopColor: "#9d6b6b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1403,
    stopColor: "#996868"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3822,
    stopColor: "#7d5555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5948,
    stopColor: "#6c4949"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7538,
    stopColor: "#664545"
  }))), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_3_",
    cx: 269.937,
    cy: 397.845,
    gradientTransform: "matrix(.703 -.712 .849 .839 -257.538 256.306)",
    gradientUnits: "userSpaceOnUse",
    r: 53.803
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#785252"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5465,
    stopColor: "#815858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9602,
    stopColor: "#8b5e5e"
  }))), _radialGradient4 || (_radialGradient4 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_4_",
    cx: 162.377,
    cy: 330.389,
    gradientTransform: "matrix(.933 .361 -.302 .78 110.652 14.233)",
    gradientUnits: "userSpaceOnUse",
    r: 158.103
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2245,
    stopColor: "#785252"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2973,
    stopColor: "#7b5454"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6431,
    stopColor: "#875c5c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8b5e5e"
  }))), _radialGradient5 || (_radialGradient5 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_5_",
    cx: 206.523,
    cy: 199.837,
    gradientTransform: "matrix(.894 .447 -.295 .59 80.765 -10.402)",
    gradientUnits: "userSpaceOnUse",
    r: 315.213
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b78e8e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4414,
    stopColor: "#9d6b6b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5685,
    stopColor: "#956666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7641,
    stopColor: "#805757"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9433,
    stopColor: "#664545"
  }))), _radialGradient6 || (_radialGradient6 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_6_",
    cx: 113.991,
    cy: 322.853,
    gradientTransform: "matrix(.989 .15 -.098 .647 32.927 96.806)",
    gradientUnits: "userSpaceOnUse",
    r: 255.734
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd0be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0955,
    stopColor: "#e6b9ad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2474,
    stopColor: "#b78e8e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5038,
    stopColor: "#9d6b6b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6746,
    stopColor: "#8f6262"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8848,
    stopColor: "#785252"
  }))), _radialGradient7 || (_radialGradient7 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_7_",
    cx: 75.984,
    cy: 260.727,
    gradientTransform: "matrix(1 0 0 .889 0 28.841)",
    gradientUnits: "userSpaceOnUse",
    r: 138.325
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.134,
    stopColor: "#785252"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6102,
    stopColor: "#a37979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6847,
    stopColor: "#aa8080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8576,
    stopColor: "#af8585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b78e8e"
  }))), _radialGradient8 || (_radialGradient8 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_8_",
    cx: 247.517,
    cy: 438.51,
    gradientUnits: "userSpaceOnUse",
    r: 99.069
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd0be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1028,
    stopColor: "#d7a79c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2039,
    stopColor: "#b88681"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2879,
    stopColor: "#a47271"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3446,
    stopColor: "#9d6b6b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4705,
    stopColor: "#8f6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6728,
    stopColor: "#7e5656"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8245,
    stopColor: "#785252"
  }))), _radialGradient9 || (_radialGradient9 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_9_",
    cx: 287.217,
    cy: 327.56,
    gradientTransform: "matrix(.703 -.712 .595 .587 -109.411 339.53)",
    gradientUnits: "userSpaceOnUse",
    r: 195.99
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#aa8080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1699,
    stopColor: "#a37575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3927,
    stopColor: "#9d6b6b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.591,
    stopColor: "#946565"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9116,
    stopColor: "#7c5555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9602,
    stopColor: "#785252"
  }))), _radialGradient10 || (_radialGradient10 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_10_",
    cx: 257.944,
    cy: 316.889,
    gradientTransform: "matrix(.703 -.712 .595 .587 -111.768 314.298)",
    gradientUnits: "userSpaceOnUse",
    r: 149.061
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd0be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0962,
    stopColor: "#ebbbad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3229,
    stopColor: "#c19089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4996,
    stopColor: "#a77573"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6035,
    stopColor: "#9d6b6b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#976767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9061,
    stopColor: "#855a5a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#785252"
  }))), _radialGradient11 || (_radialGradient11 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_11_",
    cx: 43.548,
    cy: 61.789,
    gradientTransform: "matrix(.887 -.462 .369 .71 -17.909 38.008)",
    gradientUnits: "userSpaceOnUse",
    r: 121.855
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eaaa89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1598,
    stopColor: "#cc927b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3802,
    stopColor: "#a9766b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5607,
    stopColor: "#936462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6774,
    stopColor: "#8b5e5e"
  }))), _radialGradient12 || (_radialGradient12 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_12_",
    cx: 29.121,
    cy: 110.496,
    gradientUnits: "userSpaceOnUse",
    r: 136.076
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0138,
    stopColor: "#ffd0be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2586,
    stopColor: "#eabaac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7657,
    stopColor: "#b3827e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9552,
    stopColor: "#9d6b6b"
  }))), _radialGradient13 || (_radialGradient13 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_13_",
    cx: -8.297,
    cy: 184.87,
    gradientUnits: "userSpaceOnUse",
    r: 75.793
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc3ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.255,
    stopColor: "#e9af9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7834,
    stopColor: "#b17d78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9552,
    stopColor: "#9d6b6b"
  }))), _radialGradient14 || (_radialGradient14 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_14_",
    cx: 116.995,
    cy: 194.851,
    gradientTransform: "matrix(.887 -.462 .369 .71 -58.771 110.475)",
    gradientUnits: "userSpaceOnUse",
    r: 98.477
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5541,
    stopColor: "#9d6b6b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7037,
    stopColor: "#956666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9345,
    stopColor: "#7f5757"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#785252"
  }))), _radialGradient15 || (_radialGradient15 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_15_",
    cx: 100.263,
    cy: 65.837,
    gradientTransform: "matrix(.887 -.462 .369 .71 -13.005 65.354)",
    gradientUnits: "userSpaceOnUse",
    r: 121.855
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc3ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1711,
    stopColor: "#dea596"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3867,
    stopColor: "#bb867f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5632,
    stopColor: "#a57270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6774,
    stopColor: "#9d6b6b"
  }))), _radialGradient16 || (_radialGradient16 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_16_",
    cx: 163.624,
    cy: 98.85,
    gradientTransform: "matrix(0 1 -.567 0 219.645 -64.775)",
    gradientUnits: "userSpaceOnUse",
    r: 69.613
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.055,
    stopColor: "#f4d8bc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.227,
    stopColor: "#f3d5b7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4406,
    stopColor: "#f1cca7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6763,
    stopColor: "#edbe8e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9261,
    stopColor: "#e8ab6b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9899,
    stopColor: "#e7a561"
  }))), _radialGradient17 || (_radialGradient17 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_17_",
    cx: 175.057,
    cy: 283.84,
    gradientTransform: "matrix(.703 -.712 .595 .587 -116.757 241.685)",
    gradientUnits: "userSpaceOnUse",
    r: 158.103
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0453,
    stopColor: "#b78e8e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3923,
    stopColor: "#a47575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6097,
    stopColor: "#9d6b6b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7322,
    stopColor: "#946565"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9302,
    stopColor: "#7c5555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9602,
    stopColor: "#785252"
  }))), _radialGradient18 || (_radialGradient18 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_18_",
    cx: 144.977,
    cy: 459.741,
    gradientTransform: "matrix(.703 -.712 .595 .587 -230.313 292.871)",
    gradientUnits: "userSpaceOnUse",
    r: 34.5
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e7c6bc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0544,
    stopColor: "#debbb3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2998,
    stopColor: "#bb908c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4911,
    stopColor: "#a57574"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6035,
    stopColor: "#9d6b6b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#976767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9061,
    stopColor: "#855a5a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#785252"
  }))), _radialGradient19 || (_radialGradient19 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_19_",
    cx: 160.388,
    cy: 294.756,
    gradientTransform: "matrix(.703 -.712 .595 .587 -127.611 235.752)",
    gradientUnits: "userSpaceOnUse",
    r: 189.051
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc3ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0608,
    stopColor: "#edb3a0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2274,
    stopColor: "#c28c83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3573,
    stopColor: "#a77472"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4337,
    stopColor: "#9d6b6b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.452,
    stopColor: "#996868"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5781,
    stopColor: "#815858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6559,
    stopColor: "#785252"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8642,
    stopColor: "#9a6969"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8789,
    stopColor: "#9d6b6b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8989,
    stopColor: "#a57372"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9306,
    stopColor: "#bb8a84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9695,
    stopColor: "#deaea2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffd0be"
  }))), _radialGradient20 || (_radialGradient20 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_20_",
    cx: 453.432,
    cy: 1359.113,
    gradientTransform: "matrix(.931 0 0 .112 -161.706 308.177)",
    gradientUnits: "userSpaceOnUse",
    r: 263.858
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c3a2a2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1833,
    stopColor: "#c9abab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4787,
    stopColor: "#d8c3c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6461,
    stopColor: "#e2d3d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835,
    stopColor: "#f7f3f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8982,
    stopColor: "#fff"
  }))), _radialGradient21 || (_radialGradient21 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_21_",
    cx: 11.499,
    cy: 349.136,
    gradientTransform: "matrix(.762 -.571 .647 .669 -223.177 -13.331)",
    gradientUnits: "userSpaceOnUse",
    r: 21.934
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d0cee7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3371,
    stopColor: "#a19dae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6383,
    stopColor: "#756e78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#665e66"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m476.945 426.041h-109.048v33.699h75.349c18.611.001 33.699-15.087 33.699-33.699z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m313.959 459.741h-115.467c5.601-16.931 21.426-28.364 39.259-28.364h76.209v28.364z",
    fill: "url(#SVGID_2_)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 313.959,
    cy: 369.903,
    fill: "url(#SVGID_3_)",
    r: 89.837
  }), /*#__PURE__*/React.createElement("path", {
    d: "m152.398 267.28c-25.328 1.754-45.722 22.468-47.115 47.819-1.311 23.858 13.846 44.383 35.137 51.242 6.368 2.052 10.697 7.958 10.697 14.648 0 8.35-1.095 16.664-3.256 24.729l-9.513 35.502h-6.025c-7.618 0-14.501 4.548-17.489 11.555l-2.97 6.965h21.521 37.248l34.176-127.546c1.314-4.515 2.02-9.289 2.02-14.228.001-29.259-24.731-52.743-54.431-50.686z",
    fill: "url(#SVGID_4_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m158.919 172.871 9.97 21.44c2.122 4.563 6.313 7.822 11.257 8.756l158.377 29.905c70.841 13.376 122.139 75.267 122.139 147.36 0 41.706-33.809 75.515-75.515 75.515h-10.726c-31.032 0-60.45-13.829-80.25-37.724-2.309-2.786-5.156-5.079-8.37-6.741l-153.377-87.109c-24.34-12.582-38.513-35.453-38.513-62.853l-8.572-35.914z",
    fill: "url(#SVGID_5_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m326.752 418.124c-2.309-2.786-5.155-5.079-8.37-6.741l-160.836-83.14c-24.34-12.582-39.626-37.692-39.626-65.091v-60.952l-32.582 23.308v37.645c0 27.399 15.286 52.509 39.626 65.091l160.836 83.14c3.215 1.662 6.061 3.954 8.37 6.741 19.8 23.895 49.218 37.724 80.25 37.724h10.726c3.418 0 6.783-.227 10.081-.667-26.602-3.025-51.199-16.21-68.475-37.058z",
    fill: "url(#SVGID_6_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m158.919 172.871-73.58 52.636v31.215c7.392-1.317 14.536-4.123 20.967-8.361l41.322-27.227c11.067-7.292 17.797-18.943 19.144-31.377z",
    fill: "url(#SVGID_7_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m359.574 459.741h-115.468c5.601-16.931 21.426-28.364 39.259-28.364h76.209z",
    fill: "url(#SVGID_8_)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 359.574,
    cy: 369.903,
    fill: "url(#SVGID_9_)",
    r: 89.837
  }), /*#__PURE__*/React.createElement("path", {
    d: "m286.383 369.903c0-46.809 35.8-85.257 81.514-89.456-2.741-.252-5.517-.381-8.323-.381-49.616 0-89.837 40.222-89.837 89.837 0 49.616 40.222 89.837 89.837 89.837 2.806 0 5.583-.129 8.323-.381-45.714-4.199-81.514-42.646-81.514-89.456z",
    fill: "url(#SVGID_10_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m65.958 149.131h38.573v-50.57c0-30.497-14.274-59.237-38.573-77.666z",
    fill: "url(#SVGID_11_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m113.205 141.225h-45.882c-16.958 0-32.611 9.102-41 23.84l-21.236 37.311c-1.708 3.001-2.71 6.311-2.979 9.685l85.681 11.693z",
    fill: "url(#SVGID_12_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2.108 212.061c-.227 2.852.07 5.75.908 8.547l2.049 6.837c2.918 9.734 10.374 17.448 20.003 20.695 5.909 1.993 12.031 2.96 18.12 2.933v.001h30.603l13.997-39.013z",
    fill: "url(#SVGID_13_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35.062 202.376 21.237-37.312c8.388-14.738 24.042-23.84 41-23.84h45.881c5.264 0 10.036 3.098 12.178 7.906l5.321 11.942c8.589 19.275 1.962 41.935-15.659 53.546l-41.322 27.227c-14.384 9.478-32.332 11.8-48.655 6.295-9.629-3.247-17.085-10.962-20.003-20.695l-2.05-6.837c-1.829-6.105-1.081-12.693 2.072-18.232z",
    fill: "url(#SVGID_14_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m155.358 149.131h-38.573v-50.57c0-30.497 14.274-59.237 38.573-77.666z",
    fill: "url(#SVGID_15_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m132.424 138.366v-71.293c0-18.132 8.486-35.22 22.934-46.177v94.536c0 12.666-10.268 22.934-22.934 22.934z",
    fill: "url(#SVGID_16_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m198.012 267.28c-25.328 1.754-45.722 22.468-47.115 47.819-1.311 23.858 13.846 44.383 35.137 51.242 6.368 2.052 10.698 7.958 10.698 14.648 0 8.35-1.095 16.664-3.256 24.729l-9.513 35.502h-6.025c-7.618 0-14.501 4.548-17.489 11.555l-2.97 6.965h21.521 37.248l34.176-127.546c1.314-4.515 2.02-9.289 2.02-14.228 0-29.259-24.732-52.743-54.432-50.686z",
    fill: "url(#SVGID_17_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m162.485 459.741h-13.033 37.248z",
    fill: "url(#SVGID_18_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m190.971 441.22h6.025l9.513-35.502c2.161-8.065 3.256-16.379 3.256-24.729 0-6.69-4.329-12.597-10.697-14.648-21.291-6.859-36.448-27.384-35.137-51.242 1.339-24.372 20.241-44.458 44.205-47.531-3.287-.42-6.671-.526-10.123-.287-25.328 1.754-45.722 22.468-47.115 47.819-1.311 23.858 13.846 44.383 35.137 51.242 6.368 2.052 10.698 7.958 10.698 14.648 0 8.35-1.095 16.664-3.256 24.729l-9.513 35.502h-6.025c-7.618 0-14.501 4.548-17.489 11.555l-2.97 6.965h13.033l2.97-6.965c2.987-7.008 9.87-11.556 17.488-11.556z",
    fill: "url(#SVGID_19_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 491.105c141.385 0 256-14.042 256-31.364h-512c0 17.321 114.615 31.364 256 31.364z",
    fill: "url(#SVGID_20_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.555 220.794c0 3.312-6.525 8.667-10.674 8.667s-10.674-5.355-10.674-8.667 4.779-5.998 10.674-5.998 10.674 2.686 10.674 5.998z",
    fill: "url(#SVGID_21_)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRabbit);
export default __webpack_public_path__ + "static/media/icon-rabbit.db313014beea90f0d4be430ab8a356ee.svg";
export { ForwardRef as ReactComponent };